import { render, staticRenderFns } from "./leimu.vue?vue&type=template&id=547f2dc6&scoped=true"
import script from "./leimu.vue?vue&type=script&lang=js"
export * from "./leimu.vue?vue&type=script&lang=js"
import style0 from "./leimu.vue?vue&type=style&index=0&id=547f2dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f2dc6",
  null
  
)

export default component.exports